import React from 'react';
import {
  Box,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Table
} from '@material-ui/core';
import moment from 'moment';

export default class ComponentToPrint extends React.Component {
  render() {
    const supplierCropData = this.props.supplierCropData;
    const totalAvarage = this.props.totalAvarage;
    const totalGrosWeight = this.props.totalGrosWeight;
    const daysArray = this.props.daysArray;
    const selectedSearchValues = this.props.selectedSearchValues;
    const selectedDate = this.props.selectedDate
    const Uniquedates = this.props.Uniquedates

    return (
      <div style={{ width: '100%' }}>
        <h2><center><u>TC 15 Summary Report</u></center></h2>
        <div>&nbsp;</div>
        <h4><center>Group - {selectedSearchValues.groupName} </center></h4>
        <div></div>
        <h4><center>Factory - {selectedSearchValues.factoryName}</center></h4>
        <div></div>
        <h4><center>Route - {selectedSearchValues.routeName ? selectedSearchValues.routeName : ' All Routes '}</center></h4>
        <div></div>
        <h4><center>Month - {selectedDate.toLocaleDateString('en-US', { month: 'short', year: 'numeric' })}</center></h4>
        <br></br>
        <div>
          <Table style={{ width: '100%' }} size="small" aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell style={{ border: "1px solid black", fontWeight: "bold", fontSize: "16px", padding: '2px' }} align="center">
                  Route
                </TableCell>
                <TableCell style={{ border: "1px solid black", fontWeight: "bold", fontSize: "16px", padding: '2px' }} align="center">
                  Total Weight (KG)
                </TableCell>
                {daysArray.sort((a, b) => new Date(a) - new Date(b)).map((day, index) => {
                  return (
                    <TableCell style={{ border: "1px solid black", fontWeight: "bold", fontSize: "16px", padding: '2px' }} align="center">
                      {day}
                    </TableCell>
                  );
                })}
                <TableCell style={{ border: "1px solid black", fontWeight: "bold", fontSize: "16px", padding: '2px' }} align="center">
                  Crop Date
                </TableCell>
                <TableCell style={{ border: "1px solid black", fontWeight: "bold", fontSize: "16px", padding: '2px' }} align="center">
                  Avarage
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {supplierCropData.map((row, index) => {
                return (
                  <TableRow key={index}>
                    <TableCell style={{ border: "1px solid black", padding: '2px', paddingTop: '4px', paddingBottom: '4px' }} align="left" component="th" scope="row">
                      {row.routeName}
                    </TableCell>
                    <TableCell style={{ border: "1px solid black", padding: '2px', paddingTop: '4px', paddingBottom: '4px' }} align="right" component="th" scope="row">
                      {row.totalWeight.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                    </TableCell>
                    {daysArray.sort((a, b) => new Date(a) - new Date(b)).map((day, index) => {
                      var found = row.details.find(x => moment(x.cropCollectedDate).format('DD') == day);
                      return (
                        <TableCell style={{ border: "1px solid black", padding: '2px', paddingTop: '4px', paddingBottom: '4px' }} align={found == undefined ? "center" : "right"}>
                          {found == undefined ? '-' : found.netWeight.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                        </TableCell>
                      );
                    }
                    )}
                    <TableCell style={{ border: "1px solid black", fontWeight: "bold", alignContent: "left", padding: '2px', paddingTop: '4px', paddingBottom: '4px' }} align="center" component="th" scope="row">
                      {row.dayCount}
                    </TableCell>
                    <TableCell style={{ border: "1px solid black", fontWeight: "bold", alignContent: "left", padding: '2px', paddingTop: '4px', paddingBottom: '4px' }} align="right" component="th" scope="row">
                      {row.average.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                    </TableCell>
                  </TableRow>
                );
              })}
              <TableRow>
                <TableCell style={{ border: "1px solid black", fontWeight: "bold", fontSize: "16px", padding: '2px', paddingTop: '4px', paddingBottom: '4px' }} align="left">
                  Total
                </TableCell>
                <TableCell style={{ border: "1px solid black", fontWeight: "bold", fontSize: "16px", padding: '2px', paddingTop: '4px', paddingBottom: '4px' }} align="right">
                  {totalGrosWeight.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </TableCell>
                {daysArray.sort((a, b) => new Date(a) - new Date(b)).map((day, index) => {
                  const dayTotal = supplierCropData.reduce((total, row) => {
                    const found = row.details.find(x => moment(x.cropCollectedDate).format('DD') == day);
                    return total + (found ? parseFloat(found.netWeight) : 0);
                  }, 0);
                  return (
                    <TableCell style={{ border: "1px solid black", fontWeight: "bold", padding: '2px', paddingTop: '4px', paddingBottom: '4px' }} align={dayTotal !== 0 ? "right" : "center"}>
                      {dayTotal !== 0 ? dayTotal.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '-'}
                    </TableCell>
                  );
                })}
                <TableCell style={{ border: "1px solid black", fontWeight: "bold", padding: '2px', paddingTop: '4px', paddingBottom: '4px' }} align="center">
                  {Uniquedates.length}
                </TableCell>
                <TableCell style={{ border: "1px solid black", fontWeight: "bold", padding: '2px', paddingTop: '4px', paddingBottom: '4px' }} align="right">
                  {totalAvarage.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </div>
        <div>&nbsp;</div>
      </div>
    );
  }
}
